import type { FC } from 'react';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import StandardDropdown from '@wix/da-ds/pkg/Dropdown/Preset/StandardDropdown';
import {
  mapOrderFromPAPI,
  GalleryOrder,
} from '../../../../../../utils/gallection';
import { changeGalleryOrder } from '../../../../../../actions/gallectionSection';
import { getEffectiveOrder } from '../../../../../../selectors/gallectionSection';

import s from './GalleryOrderDropdown.scss';

export interface Props {
  className?: string;
}

const GalleryOrderDropdown: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const effectiveOrder = useSelector(getEffectiveOrder);
  const currentOrder = mapOrderFromPAPI(effectiveOrder);

  const handleOrderChange = useCallback(
    (newOrder: GalleryOrder) => {
      dispatch(changeGalleryOrder(newOrder));
    },
    [dispatch]
  );

  const items = useMemo(
    () => [
      {
        value: 'relevance' as const,
        label: t('common.sortOrder.relevance'),
      },
      {
        value: 'newest' as const,
        label: t('common.sortOrder.newest'),
      },
      {
        value: 'oldest' as const,
        label: t('common.sortOrder.oldest'),
      },
    ],
    [t]
  );

  return (
    <section className={s['container']}>
      <span className={s['sort-by']}>{t('common.sortOrder')}:</span>
      <StandardDropdown
        role="menu"
        selectedValue={currentOrder ?? undefined}
        items={items}
        className={className}
        placement="bottom-end"
        onSelect={handleOrderChange}
      />
    </section>
  );
};

GalleryOrderDropdown.displayName = 'GalleryOrderDropdown';

export default GalleryOrderDropdown;
